import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteAddressProvider } from '../data-provider';
import { CACHE_KEYS } from '../types';

export const useDeleteAddress = () => {
  const queryClient = useQueryClient();

  return useMutation({
    // TODO: fix types
    // @ts-expect-error
    mutationFn: deleteAddressProvider,

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [...CACHE_KEYS.all, 'addressBookSearch'],
      });
    },
  });
};
